module.exports = __webpack_public_path__ + "img/australia-ill-defined-causes-female.46efd3d2.png";